import { CModelRepo as cModelRepo } from "@services/cmodel.repo";
import { extractErrorMessage } from "@common/utils/errorUtils";
import { SecurityDetails } from "@models/simulations/securityDetails";

export class EditSecurityDialogController {
  public security: SecurityDetails | any;
  public geographies: any;
  public sectors: any;
  public assetClasses: any;
  public saving = false;
  public fixedIncomeTypes: any;
  public currencyList = ["MUR", "EUR", "GBP", "USD", "CHF"];
  public isEditMode = false;
  public assetClass: string | undefined;

  /** @ngInject */
  constructor(
    private cModelRepo: cModelRepo,
    private $mdDialog: angular.material.IDialogService,
    private notifyjs: any
  ) {}

  $onInit(): void {
    if (!this.security) {
      this.security = {
        assetClass: this.assetClass ? { name: this.assetClass } : undefined,
      };
      this.isEditMode = false;
    } else {
      this.isEditMode = !!(this.security.id);
    }
  }

  saveSecurityChanges() {
    this.saving = true;
    if (this.isEditMode) {
      this.cModelRepo
        .updateSecurityItem(this.security.id, this.security)
        .then(() => this.$mdDialog.hide())
        .finally(() => (this.saving = false));
    } else {
      this.cModelRepo
        .saveSecurity(this.security)
        .then((savedSecurity) => this.$mdDialog.hide(savedSecurity))
        .catch((err) =>
          this.notifyjs(extractErrorMessage(err), "warning")
        )
        .finally(() => (this.saving = false));
    }
  }

  cancel() {
    this.$mdDialog.cancel();
  }
}

export const editSecurityDialog: angular.IComponentOptions = {
  template: require("../cmodel.securitymanagement/editSecurity.Dialog.html"),
  controller: EditSecurityDialogController,
  bindings: {
    security: "<?",
    assetClass: "<?",
    geographies: "<",
    sectors: "<",
    assetClasses: "<",
    fixedIncomeTypes: "<",
  },
};



// WEBPACK FOOTER //
// ./src/app/cmodel/cmodel.securitymanagement/editSecurity.Dialog.ts